import React, { useState, useRef, useCallback, useEffect } from "react";
import {
  GoogleMap,
  LoadScript,
  Polygon,
  Marker,
  InfoWindow,
} from "@react-google-maps/api";
import { google } from "react-google-maps";
import { Checkbox, Col, Row, Popover, Image } from "antd";
import { useHistory, useParams } from "react-router";
import ReactDOM from "react-dom";
import { authenticateToken } from "../../../utils/auth";
import ShopMarker from "../../../images/icon/ShopMarker.svg";
import DriverMarker from "../../../images/icon/DriverMarker.svg";
import OrderMarker from "../../../images/icon/OrderMarker.svg";
import { ConsoleSqlOutlined } from "@ant-design/icons";

const containerStyle = {
  width: "100%",
  height: "500px",
};

const OrderNeighborhoodMap = ({ ...props }) => {
  const { orderData } = props;
  const [path, setPath] = useState([]);

  // new add

  const latitude = orderData?.shopLocation?.latitude;
  const longitude = orderData?.shopLocation?.longitude;
  const type = orderData?.shop?.type;
  const fetchPolygons = async () => {
    const data = await fetch(
      `${process.env.REACT_APP_CATALOG_READER_API}/neighborhood?latitude=${latitude}&longitude=${longitude}&type=${type}`,
      {
        headers: {
          "Content-type": "application/json",
        },
      }
    );
    const response = await data.json();
    setPath(
      response.neighborhood.points.map((point) => ({
        lat: point.latitude,
        lng: point.longitude,
      }))
    );
  };
  useEffect(() => {
    fetchPolygons();
  }, []);

  // get polygon data
  const position = {
    lat: orderData?.shopLocation?.latitude,
    lng: orderData?.shopLocation?.longitude,
  };
  //new add order details map

  return (
    <>
      <LoadScript
        id="script-loader"
        googleMapsApiKey="AIzaSyBAV5ux84Aast-onJ1DOq7uspbN6doNxXQ"
        language="en"
        region="us"
      >
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={position}
          zoom={15}
        >
          <Polygon path={path} />
          <Marker
            icon={ShopMarker}
            position={{
              lat: orderData?.shopLocation?.latitude,
              lng: orderData?.shopLocation?.longitude,
            }}
          />
          <Marker
            icon={OrderMarker}
            position={{
              lat: orderData?.shippingLocation?.latitude,
              lng: orderData?.shippingLocation?.longitude,
            }}
          />
          <Marker
            icon={DriverMarker}
            position={{
              lat: orderData?.deliveryManLocation?.latitude,
              lng: orderData?.deliveryManLocation?.longitude,
            }}
          />
        </GoogleMap>
      </LoadScript>
    </>
  );
};

export default OrderNeighborhoodMap;
